import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Arrow-Fill-Up'}</title>
      <g>
        <path d="M246.2 92c2.3-2.9 5.2-4.1 8.1-4.1 2.9 0 6.4 1.2 8.1 4.1l240.2 292.4c2.3 2.9 2.9 7 1.2 11-1.7 3.5-5.2 5.8-9.3 5.8h-480.3c-4.1 0-7.5-2.3-9.3-5.8-1.7-4.1-1.2-8.1 1.2-11l240.1-292.4z" />
      </g>
    </Icon>
  )
}
